import styled, { css } from 'styled-components';
import { MediaQuery } from '../../../theme/style-helpers';
import checkMarkGreenSvg from '../../../assets/icons/CheckmarkGreen.svg';
import crossRedSvg from '../../../assets/icons/CrossRed.svg';
import PixelatedImg from '../PixelatedImg';

export const Ul = styled.ul`
  margin-top: -20px;
  padding: 0;
`;

export const Li = styled.li`
  list-style: none;
  display: flex;
  align-items: center;
  margin: 5px 0;
`;

export const CheckMarkGreenIcon = styled.img.attrs(() => ({ src: checkMarkGreenSvg }))`
  margin 0 10px 0 0;
`;

export const CrossRedIcon = styled.img.attrs(() => ({ src: crossRedSvg }))`
  margin 0 10px 0 0;
`;

export const PasswordStrengthView = styled.div`
  width: 100%;
  position: relative;

  ${MediaQuery.medium`
    width: 244px;
    margin: 30px 0 80px 0;
  `}

  margin: 32px 0;

  ${MediaQuery.medium`
    width: 244px;
  `}
`;

export const PasswordStrengthOutline = styled.div`
  width: 100%;
  height: 15px;
  border: 2px solid black;
  border-radius: 8px;
  position: absolute;
`;

export const PasswordStrengthFill = styled.div`
  height: 15px;
  transition: width 0.5s;
  ${({ lvl }) => css`
    width: ${lvl * 100}%;
    background-color: ${lvl > 0.5
    ? lvl === 1
      ? '#4B9560'
      : '#EAAA00'
    : '#CE0505'};
    border-radius: ${lvl === 1 ? '8px' : '8px 0 0 8px'};
  `}
`;

export const PixelatedImgStyled = styled(PixelatedImg)`
  display: none;

  ${MediaQuery.medium`
    display: block;
  `}
`;
